import React, { useState, useRef, useEffect } from "react";
import "./FieldVisibilityDropdown.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTableColumns,
  faChevronDown,
  faChevronUp,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";

const FieldVisibilityDropdown = ({ fields, value, onApply, onCancel }) => {
  const [open, setOpen] = useState(false);
  const [localState, setLocalState] = useState(value);
  const [activeParent, setActiveParent] = useState(null);

  const wrapperRef = useRef(null);
  const activeItemRef = useRef(null);
  const [position, setPosition] = useState(null);

  /* ----This will keep nested dropdown on parent level--- */
  useEffect(() => {
    if (activeParent) {
      const rect = activeItemRef.current.getBoundingClientRect();
      setPosition({
        top: rect.top, //+ window.scrollY,
        left: rect.left + window.scrollX,
        height: rect.height,
        width: rect.width,
      });
    }
  }, [activeParent]);

  /* ---------------- outside click ---------------- */
  useEffect(() => {
    const handler = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        // setOpen(false);
        // setActiveParent(null);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  /* ---------------- handlers ---------------- */
  const toggleParent = (field, index) => {
    const next = !localState[field.key];
    const updated = { ...localState, [field.key]: next };

    field.children?.forEach((c) => {
      updated[c.key] = next;
    });

    setLocalState(updated);

    // 🔥 FIX: sync flyout with checkbox click
    if (field.children) {
      setActiveParent(() => ({ ...field, index: index }));
    }
  };

  const toggleChild = (key, parent) => {
    const allTrue = parent.children.every((item) =>
      item.key === key ? !localState[key] : localState[item.key],
    );

    setLocalState((prev) => ({
      ...prev,
      [key]: !prev[key],
      [activeParent.key]: allTrue,
    }));
  };

  useEffect(() => {
    if (activeParent) {
      const allTrue = activeParent.children.every(
        (item) => localState[item.key],
      );
    }
  }, [localState]);

  const handleParentClick = (field, index) => {
    if (!field.children) return;

    setActiveParent((prev) =>
      prev?.key === field.key ? null : { ...field, index: index },
    );
  };

  const handleApply = () => {
    onApply(localState);
    setOpen(false);
    setActiveParent(null);
  };

  const handleCancel = () => {
    setLocalState(value);
    setActiveParent(null);
    setOpen(false);
    onCancel?.();
  };

  return (
    <div className="field-dropdown-wrapper w-100" ref={wrapperRef}>
      <button
        role="button"
        className="field-dropdown-trigger w-100 justify-content-between"
        onClick={() => setOpen((o) => !o)}
      >
        <span>
          <FontAwesomeIcon icon={faTableColumns} className="pe-1" />
          <span className="text-secondary">Show/Hide Fields</span>
        </span>
        {open ? (
          <FontAwesomeIcon icon={faChevronUp} />
        ) : (
          <FontAwesomeIcon icon={faChevronDown} />
        )}
      </button>

      {open && (
        <>
          {/* LEFT PANEL */}
          <div className="field-dropdown-panel w-100">
            <div className="field-dropdown-body">
              {fields.map((field, index) => (
                <div
                  key={field.key}
                  ref={activeParent?.key === field.key ? activeItemRef : null}
                  className={`field-item parent ${
                    activeParent?.key === field.key ? "active" : ""
                  }`}
                  onClick={() => handleParentClick(field, index)}
                >
                  <input
                    type="checkbox"
                    id={field.key}
                    className="form-check-input custom-checkbox"
                    checked={!!localState[field.key]}
                    onChange={(e) => {
                      e.stopPropagation();
                      toggleParent(field, index);
                    }}
                    onClick={(e) => e.stopPropagation()}
                  />
                  <label htmlFor={field.key}>{field.label}</label>
                  {field.children && (
                    <span className="arrow">
                      <FontAwesomeIcon icon={faChevronRight} />
                    </span>
                  )}
                </div>
              ))}
            </div>

            {/* FOOTER */}
            <div className="filter-footer border-3 p-0">
              <button
                onClick={handleCancel}
                className="cancle col-6 p-2 border-end"
              >
                Cancel
              </button>
              <button
                className="apply  col-6 p-2 border-start"
                onClick={handleApply}
              >
                Apply
              </button>
            </div>
          </div>

          {/* RIGHT FLYOUT (SEPARATE) */}
          {activeParent && (
            <div
              className="filter-right-flyout"
              style={{ top: position?.height * (activeParent.index + 1) || 0 }}
            >
              <div className="flyout-body ">
                {activeParent.children.map((child) => (
                  <label
                    key={child.key}
                    htmlFor={child.key}
                    className="field-item child text-start align-items-baseline"
                  >
                    <input
                      type="checkbox"
                      id={child.key}
                      className="form-check-input custom-checkbox"
                      checked={!!localState[child.key]}
                      onChange={() => toggleChild(child.key, activeParent)}
                    />
                    <span>{child.label}</span>
                  </label>
                ))}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default FieldVisibilityDropdown;
